import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const ShopContext = createContext(null);

const ShopContextProvider = ({ children }) => {
  const [all_product, setAllProduct] = useState([]);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://mamadora-backend.onrender.com';
  const [cartData, setCartData] = useState([]);
  const [cartCount, setCartCount] = useState(0);


  // Fetch all products and cart on app load
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        // Fetch all products first
        const res = await axios.get(`${backendUrl}/allproducts`);
        if (res.data) {
          console.log("Fetched products count:", res.data.length);
        }
        setAllProduct(res.data);

        // Then load cart
        await getCartData();
      } catch (err) {
        console.error("Failed to fetch products:", err);
      }
    };

    fetchAllData();
  }, []);


  // Fetch user cart from backend
  const getCartData = async () => {
    const token = localStorage.getItem("auth-token");
    if (!token) {
      console.warn("User not authenticated");
      return;
    }

    try {
      const response = await axios.post(`${backendUrl}/getcart`,
        {},
        {
          headers: { "auth-token": token },
        });

      console.log("Fetched cart data:", response.data);

      if (Array.isArray(response.data)) {
        setCartData(response.data);

        //  Update cart count right here
        const count = response.data.reduce(
          (total, item) => total + (item.quantity || 1),
          0
        );
        setCartCount(count);
      } else {
        console.warn("Cart data not in expected array format:", response.data);
        setCartData([]);
        setCartCount(0);
      }
    } catch (error) {
      console.error("Error fetching cart:", error);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("auth-token");
        window.location.replace("/login");
      }
    }
  };




  // Add item to Cart
  const addToCart = async (productId) => {
    try {
      console.log("Adding product:", productId);
      await axios.post(
        `${backendUrl}/addtocart`,
        { itemId: productId },
        { headers: { "auth-token": localStorage.getItem("auth-token") } }
      );
      await getCartData();
    } catch (error) {
      console.error("Failed to add to cart:", error);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("auth-token");
        window.location.replace("/login");
      }
    }
  };


  // Remove item from Cart
  const removeFromCart = async (itemId) => {
    try {
      await axios.post(
        `${backendUrl}/removefromcart`,
        { itemId },
        { headers: { "auth-token": localStorage.getItem("auth-token") } }
      );
      await getCartData();
    } catch (error) {
      console.error("Failed to remove from cart:", error);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("auth-token");
        window.location.replace("/login");
      }
    }
  };

  useEffect(() => {
    setCartCount(cartData.reduce((total, item) => total + item.quantity, 0));
  }, [cartData]);
  const getTotalCartItems = () => {
    return cartData.reduce((total, item) => total + (item.quantity || 1), 0);
  };



  // Calculate total price
  const getTotalCartAmount = () => {
    return cartData.reduce(
      (total, item) =>
        total + (item.product?.new_price || 0) * (item.quantity || 1),
      0
    );
  };


  // Keep navbar count synced automatically
  useEffect(() => {
    setCartCount(getTotalCartItems());
  }, [cartData]);


  // Clear Cart (after successful payment)
  const clearCart = () => {
    setCartData([]);
    setCartCount(0);
  };


  return (
    <ShopContext.Provider
      value={{
        all_product,
        cartData,
        addToCart,
        removeFromCart,
        getCartData,
        getTotalCartItems,
        getTotalCartAmount,
        cartCount,
        clearCart,
      }}
    >
      {children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;
